import { Component, inject, Inject, OnInit, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { EBitfCloseEventStatus } from 'common/libs/bitforce/enums/bitf.enum';
import { IBitfCloseEvent } from 'common/libs/bitforce/interfaces/bitf.interface';
import { SuperPolicyComponent, TPolicyType } from '../super-policy/super-policy.component';

export interface IPolicyDialogData {
  policyType: TPolicyType;
  interpolationMap?: Record<string, string>;
}

@Component({
  selector: 'casa-doc-policy-dialog',
  templateUrl: './policy-dialog.component.html',
  styleUrl: './policy-dialog.component.scss',
  standalone: false,
})
export class PolicyDialogComponent extends SuperPolicyComponent implements OnInit {
  protected dialogRef = inject(MatDialogRef<PolicyDialogComponent>);
  titleKey = signal<string>('');
  constructor(@Inject(MAT_DIALOG_DATA) public data: IPolicyDialogData) {
    super();
    this.titleKey.set(this.getTitle(this.data.policyType));
  }

  ngOnInit(): void {
    this.loadPolicy(this.data.policyType, this.data.interpolationMap);
  }

  onClose() {
    this.dialogRef.close({
      status: EBitfCloseEventStatus.CLOSE,
    } as IBitfCloseEvent<void>);
  }
}
